module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'form',
    ],

    config: {
        resourceConnected: false,
    },

    methods: {
        async updateAllStatusFlags(){
            await this.performAction(
                this.prepareAction('updateAllStatusFlags', undefined, undefined, {
                    source: {
                        submit: {
                            data: {
                                resourceParams: {
                                    updateAllStatusFlags: true
                                }
                            }
                        }
                    }
                })
            )
        },

        async updateAllEmployeeReports(){
            await this.performAction(
                this.prepareAction('updateAllEmployeeReports', undefined, undefined, {
                    source: {
                        submit: {
                            data: {
                                resourceParams: {
                                    filters: {
                                        refreshAll: true
                                    }
                                }
                            }
                        }
                    }
                })
            )
        },
    }
}